import React, { useCallback } from 'react';

import { usePopupState, bindHover, bindFocus, bindMenu } from 'material-ui-popup-state/hooks';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import { FormattedMessage } from 'react-intl';

import MenuItemMui from '@mui/material/MenuItem';
import MenuItemIcon from '@/pages/company/WorkspaceRoute/components/DocumentContextMenu/components/MenuItemIcon';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import ArrowLeftOutlinedIcon from '@mui/icons-material/ArrowLeftOutlined';
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';

import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material';

const MenuItemStyled = styled(MenuItemMui)(({ theme }) => ({
  '&.MuiListItem-divider': {
    borderBottom: 'none',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

const MenuItem = ({ entry, onClick }) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: `ContextMenu-Item-${entry.id}`,
  });
  const { direction } = useTheme();
  const isRtl = direction === 'rtl';

  const itemPopupState = entry.submenu
    ? {
        ...bindHover(popupState),
        ...bindFocus(popupState),
      }
    : {};

  const handleClick = useCallback(
    (event, item) => {
      popupState.close();
      onClick(event, item);
    },
    [onClick, popupState],
  );

  return (
    <MenuItemStyled
      key={entry.id}
      disabled={entry.disabled || entry.comingSoon}
      divider={entry.separator}
      onClick={(e) => handleClick(e, entry)}
      {...(entry.sx && { sx: entry.sx })}
      {...itemPopupState}
    >
      <MenuItemIcon id={entry.id} color={entry.sx && entry.sx.color} />

      <Typography variant="body2" flexGrow={1}>
        {typeof entry.title === 'string' ? (
          <FormattedMessage id={`contextMenu.${entry.id}`} defaultMessage={entry.title} />
        ) : (
          entry.title
        )}
      </Typography>

      {entry.comingSoon && (
        <Chip sx={{ ml: 1.5 }} label={<FormattedMessage id="contextMenu.comingSoon" defaultMessage="Coming soon" />} />
      )}

      {entry.submenu && (
        <>
          <Box sx={{ mr: -1, display: 'flex', alignItems: 'center' }}>
            {isRtl ? <ArrowLeftOutlinedIcon /> : <ArrowRightOutlinedIcon />}
          </Box>
          <HoverMenu
            anchorOrigin={{ vertical: 'top', horizontal: isRtl ? 'left' : 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: isRtl ? 'right' : 'left' }}
            slotProps={{ paper: { sx: { ...(isRtl ? { mr: -0.5 } : { ml: 0.5 }) } } }}
            {...bindMenu(popupState)}
          >
            {entry.submenu.map((item) => (
              <MenuItem key={item.id} entry={item} onClick={handleClick} />
            ))}
          </HoverMenu>
        </>
      )}
    </MenuItemStyled>
  );
};

export default MenuItem;
